import { createAbsoluteSize } from '@app/features/apply-react-signing/components/FieldRenderer/libs/createAbsoluteSize';
import { getTextBaseFieldMinimumSize } from '@app/features/apply-react-signing/components/FieldRenderer/libs/getTextBaseFieldMinimumSize';
import { AbsoluteSize } from '@app/features/apply-react-signing/components/FieldRenderer/types';

export const DATE_TEXT_LENGTH = 15;

export function getDateFieldCorrectedSize({
  size,
  fontSize,
  scale,
}: {
  size: AbsoluteSize;
  fontSize: number;
  scale: number;
}) {
  const currentSize = getTextBaseFieldMinimumSize(fontSize, scale);
  const minimumSize = getTextBaseFieldMinimumSize(4, scale);
  const width = Math.max(size.width, currentSize.width, DATE_TEXT_LENGTH * minimumSize.width);
  const { height } = currentSize;

  return createAbsoluteSize({ width, height });
}
